<template>
  <div class="preview m-auto">
    <div class="d-flex">
      <div class="preview-area border border-1 border-dark" :style="getCanvasSize">
        <DesignPreview />
      </div>
      <div class="control-area d-flex flex-column justify-content-center" :style="getControlAreaHeight">
        <div class="fw-bold"><p>{{ getTitleText }}</p></div>
        <div class="w-100 h-100 d-flex flex-column justify-content-end" :class="{'disable-ui disable-click':!isUploadDesign}">
          <!-- <button class="preview-btn" @click="clickPreview">
            プレビュー
          </button> -->
          <IsShowCutline />
          <PreviewMode />
          <button class="preview-btn" @click="resetCamera">
            元の位置に戻す
          </button>
          <!-- <div class="preview-border d-flex flex-column" style="border-radius: 0px 0px 4px 4px;">
            <div class="">
              <div class="col d-flex justify-content-between mx-5 my-2">
                <input class="me-2 radio-btn" type="radio" id="option1" value="0" v-model="previewMode" />
                <label class="d-block" for="option1">3Dプレビュー</label>
              </div>
              <div class="col d-flex justify-content-between mx-5 my-2">
                <input class="me-2 radio-btn" type="radio" id="option3" value="2" v-model="previewMode" />
                <label for="option3">2Dプレビュー</label>
              </div>
            </div>

            <hr class="my-0">

            <div class="row m-0">
              <div class="col pl-3 mb-1 pt-1">
                <div class="fw-bold text-start" style="font-size: 13px;">カットライン</div>
                <div class="d-flex pt-1">
                  <div
                    class="color_box"
                    v-for="(color, index) in this.getColorList"
                    v-bind:key="index"
                    :style="getCutlineBoxStyle(index)"
                    @click="clickCutlineBox(index)"
                  />
                </div>
              </div>
              <div class="col pl-3 mb-1 pt-1">
                <div class="fw-bold text-start" style="font-size: 13px;">背景</div>
                <div class="d-flex pt-1">
                  <div
                    class="color_box"
                    v-for="(color, index) in this.getColorList"
                    v-bind:key="index"
                    :style="getBackgroundBoxStyle(index)"
                    @click="clickBackgroundBox(index)"
                  />
                </div>
              </div>
            </div>
            <div class="status-error-color text-start m-2" style="font-size: 13px;">
              ※ 確認用のため仕上がりカラーには影響しません
            </div>
          </div>
          <div class="preview-border" style="border-radius: 4px 4px 0px 0px; margin-top: 8px;">
            <p class="preview-title m-0">プレートプレビュー</p>
          </div>
          <div class="preview-border d-flex flex-column" style="border-radius: 0px 0px 4px 4px;">
            <div class="">
              <div class="col d-flex justify-content-between mx-5 my-2">
                <input class="me-2 radio-btn" type="radio" id="option1" value="0" v-model="cutlineMode" />
                <label class="d-block text-start" style="width: 100px;" for="option1">ON</label>
              </div>
              <div class="col d-flex justify-content-between mx-5 my-2">
                <input class="me-2 radio-btn" type="radio" id="option3" value="1" v-model="cutlineMode" />
                <label class="text-start" for="option3" style="width: 100px;">OFF</label>
              </div>
            </div>
          </div>
          <div class="preview-border" style="border-radius: 4px 4px 0px 0px;">
            <p class="preview-title m-0">カットライン表示</p>
          </div> -->
        </div>
      </div>
    </div>

    <Precautions>
      <p class="m-0">・カットラインとデザインが交わっている箇所はプリントが剥がれやすくなります。</p>
      <p class="m-0">・プレビューによるデザインとカットラインを元に制作致します。</p>
      <p class="m-0">・アタッチメントのつけ忘れ、5mm以下の小さなパーツは再現性の低下や破損に繋がります。また保証対象外となりますのでご注意ください。</p>
    </Precautions>
  </div>

</template>

<script>
import {
  ProductId,
  PreviewColorList,
  GetCanvasSize
} from "@/js/Const.js";
import { CreateImageElement } from "@/js/CommonFunc.js";
import { OffScreen } from "@/js/OffScreen.js";
import IsShowCutline from "@/components/acyrpro/preview/IsShowCutline.vue";
import PreviewMode from "@/components/acyrpro/preview/PreviewMode.vue";
import DesignPreview from "@/components/acyrpro/preview/DesignPreview.vue";
import Precautions from "@/components/acyrpro/preview/Precautions.vue";


export default {
  name: "CenterViewPreview_Ap",
  props: {},
  components: {
    DesignPreview,
    IsShowCutline,
    PreviewMode,
    Precautions,
  },
  data: function () {
    return {
      selectProductData: null,
    };
  },
  created() {
    // チュートリアル開始
    // this.$store.commit("showPreviewTutorial");

  },
  watch: {
    "$store.state.selectCutlineColor": async function () {
      let canvasSize = GetCanvasSize(this.$store.state.selectProductId);
      const imageWidth = canvasSize.width;
      const imageHeight = canvasSize.height;
      let offScreen = new OffScreen(imageWidth, imageHeight);

      let image = await CreateImageElement(this.$store.state.frameCutlineImageURL);
      offScreen.drawImage(image, 0, 0, imageWidth, imageHeight);
      offScreen.replacement(PreviewColorList[this.$store.state.selectCutlineColor]);

      const blob = await new Promise((resolve) => {
        offScreen.toBlob(function (blob) {
          resolve(blob);
        });
      });

      this.$store.commit("setFrameCutlineImageURL", URL.createObjectURL(blob));
    },
  },
  computed: {
    isUploadDesign() {
      return this.$store.state.designImageURL != null;
    },
    isUploadCutline() {
      return this.$store.state.frameCutlineImageURL != null;
    },
    getTitleText() {
      switch (this.$store.state.selectProductId) {
        case ProductId.S:
        case ProductId.S_SVG:
        case ProductId.S_SHARE:
          return "Sサイズ (簡易編集)";
        case ProductId.M:
        case ProductId.M_SVG:
        case ProductId.M_SHARE:
          return "Mサイズ (簡易編集)";
        case ProductId.L:
        case ProductId.L_SVG:
        case ProductId.L_SHARE:
          return "Lサイズ (簡易編集)";
        default:
          return "";
      }
    },
    getColorList() {
      return PreviewColorList;
    },
    getBackgroundBoxStyle() {
      return function (index) {
        return {
          border:
            this.$store.state.selectBackgroundColor == index ? "solid 2px" : "solid 1px",
          "border-color":
            this.$store.state.selectBackgroundColor == index ? "#000000" : "#999999",
          "background-color": PreviewColorList[index],
        };
      };
    },
    getCutlineBoxStyle() {
      return function (index) {
        return {
          border:
            this.$store.state.selectCutlineColor == index ? "solid 2px" : "solid 1px",
          "border-color":
            this.$store.state.selectCutlineColor == index ? "#000000" : "#999999",
          "background-color": PreviewColorList[index],
        };
      };
    },
    getCanvasSize(){
      let canvasSize = GetCanvasSize(this.$store.state.selectProductId);
      return {
        "width":canvasSize.canvasScreenSizeWidth+"px",
        "height":canvasSize.canvasScreenSizeHeight+"px",
        };
    },
    getControlAreaHeight(){
      let canvasSize = GetCanvasSize(this.$store.state.selectProductId);
      return {
        "height":canvasSize.canvasScreenSizeHeight+"px",
        };
    },
  },
  methods: {
    async clickPreview(){
      let canvasSize = GetCanvasSize(this.$store.state.selectProductId);
      const imageWidth = canvasSize.width;
      const imageHeight = canvasSize.height;
      let offScreen = new OffScreen(imageWidth, imageHeight);

      if( this.$store.state.designImageURL ){
        let image = await CreateImageElement(this.$store.state.designImageURL);
        offScreen.drawImage(image, 0, 0, imageWidth, imageHeight);
      }

      if( this.$store.state.frameCutlineImageURL ){
        let image = await CreateImageElement(this.$store.state.frameCutlineImageURL);
        offScreen.drawImage(image, 0, 0, imageWidth, imageHeight);
      }

      const blob = await new Promise((resolve) => {
        offScreen.toBlob(function (blob) {
          resolve(blob);
        });
      });
      this.$store.commit("showImagePreview", URL.createObjectURL(blob));
    },
    resetCamera(){
      if( this.$store.state.resetCameraFunc ) this.$store.state.resetCameraFunc();
    }

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.preview{
  max-width: 805px;
  width: 100%;
  padding: 16px 32px;

}

.control-area{
  margin-left: 16px;
  width: 243px;
}

.preview-btn{
  height: 40px;
  margin-top: 8px;
  font-weight: bold;
  color: $primary-main-color;
  border: 2px solid $primary-main-color;
  border-radius: 4px;
  background-color: $background-white-color;
}

.preview-border{
  border: 2px solid $primary-main-color;
  background-color: $background-white-color;
}

.preview-title{
  color: $text-white-color;
  background-color: $primary-main-color;
}

.color_box {
  height: 25px;
  width: 25px;
  margin: 2px;
  border-radius: 5px;
}

.radio-btn{
  height: 25px;
  width: 25px;
  accent-color: #8593bc;
}

.disable-ui {
  opacity: 0.5;
}

.disable-click {
  pointer-events: none;
}
</style>
